import { render, staticRenderFns } from "./SampleInjectionsListComponent.vue?vue&type=template&id=9758ce70&scoped=true&"
import script from "./SampleInjectionsListComponent.vue?vue&type=script&lang=js&"
export * from "./SampleInjectionsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./SampleInjectionsListComponent.vue?vue&type=style&index=0&id=9758ce70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9758ce70",
  null
  
)

export default component.exports